import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Текстовая часть карточки, у которой содержимое идёт от края.
 *
 * Нужна плиткам: портрет во всю ширину, а подпись под ним — с полями. Без неё
 * экраны оборачивали текст вкуишным <Div>, а он даёт платформенные 16 px — на
 * колонке в 163 px это съедает половину строки.
 */
export function CardText({ children }: { children: ReactNode }) {
  return <div className={styles.cardText}>{children}</div>;
}
